// Font loader for jsPDF with Romanian diacritics support
// Uses Noto Serif (similar to Times New Roman) with full Unicode support

export const addTimesFont = async (pdf) => {
  try {
    // Fetch Noto Serif font from Google Fonts CDN (Latin Extended - supports Romanian)
    // Noto Serif is visually similar to Times New Roman and has excellent diacritics support
    const fontUrl = 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZqFCjwM0Lhq_Szw.ttf';
    
    const response = await fetch(fontUrl);
    
    if (!response.ok) {
      throw new Error('Failed to fetch font');
    }
    
    const arrayBuffer = await response.arrayBuffer();
    
    // Convert ArrayBuffer to base64
    const uint8Array = new Uint8Array(arrayBuffer);
    let binary = '';
    for (let i = 0; i < uint8Array.length; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    const base64 = btoa(binary);
    
    // Add font to jsPDF virtual file system
    pdf.addFileToVFS('NotoSerif-Regular.ttf', base64);
    pdf.addFont('NotoSerif-Regular.ttf', 'NotoSerif', 'normal');
    pdf.setFont('NotoSerif');
    
    return true;
  } catch (error) {
    console.error('Error loading NotoSerif font for PDF:', error);
    // Fallback - keep default font
    return false;
  }
};

// Alias for backward compatibility
export const addRobotoFont = addTimesFont;
